// extracted by mini-css-extract-plugin
export default {"popup":"ModalOverlay_popup__vcTR+","flareAnimation":"ModalOverlay_flareAnimation__fjxz0"};